/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import type { SnapSearchViewFlags } from '../types';

export const SNAP_SEARCH_VIEW_FEATURE_FLAGS =
  'snap_search_feature_flags' as const;

export const SNAP_SEARCH_VIEW_FLAGS_DEFAULT: SnapSearchViewFlags = {
  snap_recent_searches_enabled: true,
  snap_one_way_enabled: false,
  snap_search_banner: false,
  snap_lfc_enabled: false,
  snap_bkk_dmk_mapping_enabled: true,
  snap_recent_search_max_count: 5,
  snap_combined_date_field_enabled: false,
  hotel_snap_unified_listing_enabled: false,
  snap_total_guest_price_enabled: false,
  snap_list_filter_enabled: true,
  snap_price_filter_enabled: true,
  snap_promotion_filter_enabled: true,
  snap_amenities_filter_enabled: true,
  snap_star_rating_filter_enabled: true,
  snap_guest_rating_filter_enabled: true,
  snap_property_type_filter_enabled: false,
  snap_neighbourhood_filter_enabled: true,
  snap_location_filter_enabled: true,
  snap_enable_portal_usage: false,
  hotel_list_default_page_size: 100,
};
